<template>
  <span class="svg-icon menu-icon">
    <inline-svg src="/media/cirx/menu_icons/dashboard_icon.svg" />
  </span>
</template>

<script>
export default {
  name: "DashboardIcon",
};
</script>

<style scoped lang="scss"></style>
